<template>
  <div class="container mx-auto px-4">
    <div
      class="relative grid items-center gap-8 mt-6 mb-12 md:grid-cols-2 lg:mt-8 lg:mb-24"
    >
      <div>
        <h1
          class="mt-4 md:mt-6 lg:mt-8 text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl"
          v-html="title"
        ></h1>
        <div
          class="mt-4 text-lg md:mt-6 lg:mt-8 md:text-xl text-grow"
          v-html="description"
        ></div>
        <div class="flex mt-4 xs:flex-row flex-col w-fit gap-4 md:mt-6 lg:mt-8">
          <a
            :href="useRuntimeConfig().public.app_user_url"
            target="_blank"
            rel="noopener noreferrer"
            class="text-btn h-12 px-5 font-semibold bg-success hover:bg-successshades text-white whitespace-nowrap transition inline-flex items-center justify-center rounded-full"
          >
            {{ $t("try_our_service") }}
          </a>
          <nuxt-link
            class="text-btn h-12 px-5 font-semibold box-border border text-neutrals-opaque-13 bg-white hover:bg-black/10 whitespace-nowrap transition inline-flex items-center justify-center rounded-full"
            :to="localePath('/contact-us')"
            >{{ $t("contact") }}</nuxt-link
          >
        </div>
      </div>
      <div class="h-full hidden md:flex items-center justify-center">
        <nuxt-img
          loading="lazy"
          src="/personal/social.png"
          alt="qr-code-for-personal"
          format="webp"
          height="360"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
export default defineComponent({
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  setup() {
    return {
      localePath: useLocalePath(),
    };
  },
});
</script>
